import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LicensingService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;
    return `${base}${path}`;
  }

  getLicensings(page: number, pageSize: number): Observable<any> {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('pageSize', pageSize);
    return this.http.get<any>(this.url('/getlicensingRegistration'), { params });
  }

  getProducts(page: number, pageSize: number): Observable<any> {
    let params = new HttpParams();
    params = params.append('Page', page);
    params = params.append('PageSize', pageSize);
    return this.http.get<any>(this.url('/product-registration'), { params });
  }

  save(payload: any): Observable<any> {
    return this.http.post(this.url('/licensingRegistration'), payload);
  }
}
